export default "__VITE_ASSET__pZwAHA_0__"